import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  external?: boolean;
  variant?: "default" | "mobile";
}

const NavLink = ({ 
  to, 
  children, 
  className, 
  onClick, 
  external = false,
  variant = "default" 
}: NavLinkProps) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  const baseStyles = {
    default: "group relative text-xs font-medium transition-all duration-300 whitespace-nowrap",
    mobile: "text-sm font-medium transition-colors hover:text-primary"
  };

  const activeStyles = {
    default: isActive ? "text-primary" : "text-muted-foreground hover:text-primary",
    mobile: isActive ? "text-primary" : "text-muted-foreground"
  };

  const combinedClassName = cn(
    baseStyles[variant],
    activeStyles[variant],
    className
  );

  if (external) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className={combinedClassName}
        onClick={onClick}
      >
        {variant === "default" ? (
          <span className="relative z-10 px-1.5 py-0.5 rounded-md transition-all duration-300 group-hover:bg-primary/10">
            {children}
          </span>
        ) : (
          children
        )}
      </a>
    );
  }

  return (
    <Link
      to={to}
      className={combinedClassName}
      onClick={onClick}
    >
      {variant === "default" ? (
        <span className="relative z-10 px-1.5 py-0.5 rounded-md transition-all duration-300 group-hover:bg-primary/10">
          {children}
        </span>
      ) : (
        children
      )}
    </Link>
  );
};

export { NavLink };
